<script>

export default {
    name: 'dt-footer',
}

</script>

<template lang="pug">

div.dt-footer
    h3.dt-footer__text
        | © 2017.
        |
        span(v-if="isENG") Tensor networks and deep learning for applications in data mining.
        span(v-if="isRUS") Тензорные сети и глубинное обучение для интеллектуального анализа данных.
        br
        span(v-if="isENG") All rights reserved.
        span(v-if="isRUS") Все права защищены.
    figure.dt-footer__imgs.dt-footer--imgs(v-if="isENG")
        a.dt-footer--imgs__img(
            href="http://минобрнауки.рф/lang/en", target="_blank")
            img(src='~@dt/assets/pictures/logo_minedu_eng.png')
        a.dt-footer--imgs__img(
            href="http://www.skoltech.ru/en/", target="_blank")
            img(src="~@dt/assets/pictures/logo_skoltech_eng.png")
    figure.dt-footer__imgs.dt-footer--imgs(v-if="isRUS")
        a.dt-footer--imgs__img(
            href="http://минобрнауки.рф/lang/ru", target="_blank")
            img(src="~@dt/assets/pictures/logo_minedu_rus.png")
        a.dt-footer--imgs__img(
            href="http://www.skoltech.ru/?lang=ru", target="_blank")
            img(src="~@dt/assets/pictures/logo_skoltech_rus.png")
</template>

<style lang="sass">

@import '~@dt/sass/root.sass'

.dt-footer
  +flex(row, nowrap, space-between, center)
  +flex-direction($milli: column)
  +padding(15px 15px 25px)
  background-image: url("~@dt/assets/pictures/abstractnet.jpg")
  background-position: 100% 100%
  background-size: cover
  &__text
    flex: 0 1 auto
    +margin(0 5px 20px 0)
    +color-font(light1)
    +font(base-bold)
  &__imgs
    +flex(row, nowrap, space-around)
    +flex-direction($micro: column)
.dt-footer--imgs
  &__img
    +flex(row, nowrap, center, center)
    +margin(0 20px, $milli: 20px 20px 0, $micro: 20px 0 0)
    +padding(30px)
    +shadow(box3d-dark)
    &:hover
      +shadow(box3d-dark-small)
</style>



// WEBPACK FOOTER //
// site/deeptensor/components/Footer.vue